/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Household_Reason_QuotaInputs */

const fr_household_reason_quota = /** @type {(inputs: Household_Reason_QuotaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quota de séances atteint`)
};

/**

* @param {Household_Reason_QuotaInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const household_reason_quota = /** @type {((inputs?: Household_Reason_QuotaInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Household_Reason_QuotaInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_household_reason_quota(inputs)
});